const words = [
  "Global Procurement",
  "Private Aviation",
  "VIP Access",
  "Bespoke Travel",
  "Fine Dining",
  "Yacht Charter",
];

export const Marquee = () => {
  return (
    <section
      data-testid="marquee-section"
      className="relative bg-navy py-16 md:py-24 overflow-hidden"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {[...words, ...words].map((w, i) => (
          <span
            key={i}
            className="font-serif italic text-5xl md:text-7xl lg:text-8xl text-gold/30 mx-8 flex items-center"
          >
            {w}
            <span className="mx-8 h-2 w-2 rounded-full bg-gold/40 not-italic" />
          </span>
        ))}
      </div>
    </section>
  );
};
